import { ARTICLE_LIST } from '@helpers/api';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import FilteredListing from '@stories/Components/Filtering/FilteredListing/FilteredListing';
import queryString from 'query-string';
import React from 'react';
import { JsonParam, NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import S from './MediaCentreListing.styles';
import ArticleCard from '@stories/Components/Cards/ArticleCard/ArticleCard';
import { ThemeOption } from '@helpers/brand';
import { Helmet, HelmetData } from 'react-helmet-async';
const MediaCentreListing = ({ areaOfLaw, pageContext, initialData, mediaTypes, sortByOptions, errorText, staticAreaOfLaw, staticArticleType, }) => {
    const helmetData = new HelmetData({});
    // Define query string parameters.
    const [queryParams, setQueryParams] = useQueryParams({
        pageIndex: NumberParam,
        filter: withDefault(JsonParam, {}),
        searchTerm: StringParam,
        sortBy: StringParam,
    });
    const [filterTemp, setFilterTemp] = React.useState(queryParams.filter);
    // Get page index or default.
    const pageIndex = queryParams.pageIndex ?? 1;
    // Get sort by or default.
    const sortByValue = queryParams.sortBy ?? sortByOptions[0].value;
    const pageSize = 20;
    // Construct API url.
    const filter = {
        "areaOfLaw": staticAreaOfLaw ? [staticAreaOfLaw] : queryParams.filter.areaOfLaw,
        "mediaTypes": staticArticleType ? [staticArticleType] : queryParams.filter.mediaTypes
    };
    const parameters = queryString.stringify({
        docId: pageContext?.documentId,
        filter: JSON.stringify(filter),
        pageIndex: pageIndex,
        pageSize: pageSize,
        sortBy: sortByValue,
    });
    const apiUrl = `${ARTICLE_LIST}?${parameters}`;
    // Fetch data.
    const { data, error, complete } = useApi(apiUrl);
    // Get items from response or initial items.
    const items = data?.items ?? initialData.items;
    const totalItems = data?.totalItems ?? initialData.totalItems;
    const pageAmount = totalItems / pageSize;
    function getAbsUrl(relativeUrl) {
        if (typeof window !== "undefined") {
            return window.location.origin + window.location.pathname + relativeUrl;
        }
        return undefined;
    }
    function getNextPageUrl(query) {
        const nextIndex = (parseInt(query.pageIndex, 10) || 1) + 1;
        if (nextIndex > pageAmount) {
            return undefined;
        }
        const search = queryString.stringify({
            pageIndex: nextIndex,
        });
        return getAbsUrl(`?${search}`);
    }
    function getPrevPageUrl(query) {
        const prevIndex = (parseInt(query.pageIndex, 10) || 1) - 1;
        if (prevIndex < 1) {
            return undefined;
        }
        const search = queryString.stringify({
            pageIndex: prevIndex,
        });
        return getAbsUrl(`?${search}`);
    }
    const prevUrl = getPrevPageUrl(queryParams);
    const nextUrl = getNextPageUrl(queryParams);
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, { helmetData: helmetData },
            prevUrl ? React.createElement("link", { rel: "prev", href: prevUrl }) : null,
            nextUrl ? React.createElement("link", { rel: "next", href: nextUrl }) : null),
        React.createElement(FilteredListing, { sideFilterProps: {
                checkboxFilters: [mediaTypes, areaOfLaw],
                sideDropDownFilter: [],
                activeSideFilter: filter,
                sideDropDownFilterValue: filterTemp,
                submitSideFilter: () => {
                    setQueryParams({ filter: filterTemp, pageIndex: 1 }, 'pushIn');
                },
                onCheckboxChange: (name, value, replace, update) => {
                    if (replace) {
                        setFilterTemp({ ...filterTemp, [name]: [value] });
                        if (value === '') {
                            const filter = { ...filterTemp };
                            delete filter[name];
                            setFilterTemp(filter);
                        }
                        return;
                    }
                    const passValues = filterTemp[name];
                    const values = new Set(passValues ?? []);
                    if (values.has(value)) {
                        values.delete(value);
                    }
                    else {
                        values.add(value);
                    }
                    // Remove key altogether if no values.
                    if (values.size === 0) {
                        if (update) {
                            const filter = { ...filterTemp };
                            delete filter[name];
                            setFilterTemp(filter);
                            setQueryParams({ filter, pageIndex: 1 }, 'pushIn');
                        }
                        else {
                            const filter = { ...filterTemp };
                            delete filter[name];
                            setFilterTemp(filter);
                        }
                        return;
                    }
                    // Otherwise updated filter with new values.
                    setFilterTemp({ ...filterTemp, [name]: [...values] });
                    // Used to remove filter values from the query string if they are already present and need removing
                    if (update) {
                        setQueryParams({ filter: { ...queryParams.filter, [name]: [...values], pageIndex: 1 } }, 'pushIn');
                    }
                }
            }, errorText: errorText, error: error, filtersProps: {
                filters: [],
                sortByOptions: sortByOptions,
                sortByValue: sortByValue,
                onFilterChange: (key, val) => setQueryParams({ [key]: val, pageIndex: 1 }),
                onSortChange: (val) => (setQueryParams({ sortBy: val, pageIndex: 1 })),
            }, items: items, complete: complete, pageSize: pageSize, pageIndex: pageIndex, renderItems: (items) => (React.createElement(S.ItemList, null, items.map((item, i) => (React.createElement(S.Item, { key: i },
                React.createElement(ArticleCard, { ...item, order: i, theme: ThemeOption.Grey })))))), totalItems: totalItems, hideUserFilters: staticAreaOfLaw || staticArticleType ? true : false, onPageChange: (pageIndex) => {
                setQueryParams({ pageIndex });
            }, onReset: () => {
                setQueryParams({ filter: staticAreaOfLaw || staticArticleType ? filter : {}, pageIndex: 1 }, 'pushIn');
                setFilterTemp({});
            } })));
};
export default withQueryParams(MediaCentreListing);
